// Default settings and optional sample data (taken from the August 2026 invoice).
import { DEFAULT_TAGS, suggestTag } from "./tags";

// A "brand" is a business profile you invoice as (agency branding). You can keep several,
// e.g. Alphabet Technology India and a UK trading name, each with its own look and bank.
export const DEFAULT_BRAND = {
  id: "default",
  name: "Alphabet Technology",
  tagline: "",
  address: "67 Tagore Nagar Chitrakoot, Jaipur, 302021",
  state: "Rajasthan",
  country: "India",
  gstin: "08AZSPP0966H2ZP",
  pan: "",
  lut: "",
  email: "info@alphabettechnology.in",
  phone: "",
  website: "",
  logo: "",
  signature: "",
  signatory: "Authorised Signatory",
  accent: "#C62828",
  template: "classic",
  prefix: "",
  bank: {
    accountName: "ALPHABET TECHNOLOGY",
    method: "FPS / CHAPS / BACS",
    currency: "GBP",
    accountNumber: "",
    sortCode: "",
    ifsc: "",
    swift: "",
    iban: "",
    bankName: "Banking Circle",
    bankAddress: "68 King William Street, London, EC4N 7HR, United Kingdom",
  },
  // Separate bank block for domestic INR invoices (optional).
  bankInr: {
    accountName: "",
    accountNumber: "",
    ifsc: "",
    bankName: "",
    branch: "",
    upiId: "",
  },
};

export const DEFAULT_SETTINGS = {
  defaultBrandId: "default",
  numbering: {
    prefix: "AT",
    separator: "/",
    includeFY: true,
    resetEachFY: true,
    padding: 0,
    start: 1,
    counters: { "AT|2026-27": 13 },
  },
  defaults: {
    format: "export",
    currency: "GBP",
    taxMode: "export",
    taxRate: 18,
    dueDays: 0,
    sac: "998361",
    notes: "",
    terms: "",
    showQr: true,
    qrText: "",
    showHsn: false,
    showClientLogo: true,
    dateStyle: "iso",
    reminderDays: 7,
    prorate: "30",
  },
  backup: { lastExportAt: "", remindDays: 7 },
  tags: DEFAULT_TAGS,
};

const SAMPLE_PROJECTS = [
  ["Aakaar Child Development Centre", "5 keywords", 66],
  ["Acequ", "5 Keyword", 66],
  ["Amshar Serengeti", "3 Keywords", 47],
  ["Anglie Johns", "5 Keywords", 66],
  ["Antlop Google ads", "", 100],
  ["Antlop Investment Properties Inc.", "10 Keywords", 95],
  ["Azone", "20 Keyword", 183],
  ["Bluebird Barnet", "4 Keyword", 50],
  ["Bluebird Enfield", "4 Keyword", 50],
  ["Bpm Reia", "5 keyword", 66],
  ["BPM Reia Google ads", "", 100],
  ["Bright Valeting", "5 Keyword", 66],
  ["Broadway Dental Studio Mill Hill", "12 Keyoword", 100],
  ["Builder To Contributor LLC", "2 Keywords", 47],
  ["Creek Tours and Travel Limited", "3 Keywords", 47],
  ["Crofts", "3 Keyword", 47],
  ["D-LYT Vapes", "3 Keywords", 47],
  ["D-Lyt Vaps Website Maintenance", "", 95],
  ["Ealing Hearing", "8 Keyword", 84],
  ["Ealing Hearing Chatbot (Advanced) Maintenance", "", 30],
  ["Elevan Motors Google ads", "", 100],
  ["Eleven Motors", "8 Keywords", 84],
  ["Estleon Adventures Tours Travel and Safaris Ltd", "3 Keywords", 47],
  ["Excel Global College", "5 Keywords", 66],
  ["Flight and Safaris International Limited", "3 Keywords", 47],
  ["Frame The Wild Moments", "3 Keywords", 47],
  ["HIIT Gym", "10 Keyword", 95],
  ["HIIT Gym GMB", "", 100],
  ["Ignite Re Wealth", "3 Keyword", 47],
  ["ISL", "5 Keyword", 66],
  ["Jalsa", "3 Keyword", 47],
  ["Jennifer Franch", "3 Keyword", 47],
  ["JTS", "5 Keywords", 66],
  ["JTS Ads", "", 100],
  ["Kilimora Adventure", "3 Keywords", 47],
  ["Knight Shutters & Improvements", "8 Keyword", 84],
  ["Knight Shutters Ads", "", 50],
  ["Latin Reia", "10 Keywords", 95],
  ["Linkedin Posts", "", 60],
  ["Mantoz GEO", "", 50],
  ["Mika", "20 Keyword", 183],
  ["MP Shah", "3 Keyword", 47],
  ["Nip Nap", "5 Keyword", 66],
  ["Opencentric", "2 Keyword", 47],
  ["Pinner Green Dental", "8 Keyword", 84],
  ["POA Tank/Jumbo Quality", "5 Keyword", 66],
  ["PolyPlay SEO", "5 Keyword", 66],
  ["Prima Decor Painters", "20 Keyword", 183],
  ["R World", "3 Keyword", 47],
  ["Radient Power", "3 Keywords", 47],
  ["Redtours WhatsApp & email marketing", "", 145],
  ["Rein", "20 Keywords", 183],
  ["Safari Land", "20 Keywords", 183],
  ["Sattavis", "8 Keyword", 84],
  ["Saturn Pharmacy", "3 Keyword", 47],
  ["Savage Wilderness SEO", "3 Keyword", 47],
  ["Skypex", "5 Keyword", 66],
  ["Social Media", "", 1000],
  ["Sona Tours Email Marketing", "", 50],
  ["Sona Tours Google Ads", "", 70],
  ["Sonatours Blue Tick (For Instagram and Facebook)", "", 18],
  ["Sonatours Chatbot", "", 100],
  ["Sonatours Social Media", "", 350],
  ["Spice Travel Google Ads", "", 50],
  ["Taste of Lahore", "8 Keyword", 84],
  ["Taste of Lahore Events", "5 Keyword", 66],
  ["Telematics", "8 Keywords", 84],
  ["The Excelsis", "2 Keyword", 47],
  ["The Excelsis Website Maintenance", "", 19],
  ["Top Time SEO", "8 Keyword", 84],
  ["Top Time Website Maintenance", "", 19],
  ["Trioscape", "3 Keywords", 39],
  ["Venue 5 SEO", "3 Keyword", 47],
  ["Visual Detailing", "5 Keywords", 66],
  ["Visuals Kits Ltd", "5 Keywords", 66],
  ["Yvonne Beck", "2 Keyword", 47],
  ["Zenvy GEO", "5 Location", 240],
  ["Zenvy Wellness", "20 Keywords", 183],
  ["Zenvy Wellness Meta ads", "", 150],
];

export function buildSampleData(uid) {
  const clientId = uid();
  const now = new Date().toISOString();
  const client = {
    id: clientId,
    name: "Strategic Web Success Group",
    contactPerson: "",
    email: "",
    phone: "442033224020",
    address: "Headstone Lane",
    city: "",
    state: "",
    country: "United Kingdom",
    gstin: "",
    currency: "GBP",
    taxMode: "export",
    notes: "Monthly SEO / ads / social retainer billing",
    createdAt: now,
  };
  const projects = SAMPLE_PROJECTS.map(([name, service, rate]) => ({
    id: uid(),
    clientId,
    name,
    service,
    tag: suggestTag(`${name} ${service}`),
    billing: "monthly",
    rate,
    qty: 1,
    taxRate: 18,
    status: "active",
    startDate: "",
    notes: "",
    createdAt: now,
  }));
  return { client, projects };
}
